import React, {Component} from "react";
import {Link} from "react-router";
import {cx} from "../../lib/ClassSet";
import '../../components/Button.scss';
import "./AccountHeader.css";

class AccountHeader extends Component {

  render() {
    let classes = cx({
      "AccountHeader": true,
      "u-selected": this.props.selected,
      "u-vip": this.props.vip
    })
    return (
      <div className={classes}>
        <div className="header" onClick={this.props.onSelect}>
          <div>
            <div className="name">{this.props.name} <span className="vip">VIP</span> <span className="accountId">{this.props.accountId}</span></div>
            <div className="type">{this.props.accountType}</div>
          </div>
          <Link to={`/accounts/${this.props.accountId}`} className="Button s-primary"><span className="label">View Account</span></Link>
        </div>
      </div>
    )
  }
}


AccountHeader.defaultProps = {
  name: "Personal",
  accountType: "personal",
  accountId: "",
  selected: false
}

export default AccountHeader;